import { DailyTradeReport } from '../models/DailyTradeReports';

export const sortReportsByDate = (
  reports: DailyTradeReport[],
): DailyTradeReport[] =>
  reports.sort(
    (a, b) =>
      new Date(b.reportDateISO).getTime() - new Date(a.reportDateISO).getTime(),
  );
